import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { Home1Component } from './home1/home1.component';
import { RestTakeawayComponent } from './rest-takeaway/rest-takeaway.component';

import { SeoResolver } from '../shared/services/seo-resolver.service';
import { SeotaResolver } from '../shared/services/seota-resolver.service';
import { DomicilioResolver } from '../shared/services/domicilio-resolver.service';

import { DashboardComponent } from '../pages/account/dashboard/dashboard.component';
import { LoginComponent } from '../pages/account/login/login.component';
import { ProfileComponent } from '../pages/account/profile/profile.component';
import { FaqComponent } from '../pages/faq/faq.component';
import { CookiePolicyComponent } from '../pages/cookie-policy/cookie-policy.component';
import { PrivacyComponent } from '../pages/privacy/privacy.component';
import { TermsComponent } from '../pages/terms/terms.component';
import { SuggestRestaurantComponent } from '../pages/suggest-restaurant/suggest-restaurant.component';
import { DomicilioComponent } from './domicilio/domicilio.component';
import { RecensioniComponent } from '../pages/recensioni/recensioni.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CheckComponent } from './check/check.component';
import { SuccessComponent } from './checkout/success/success.component';
import { CheckpayComponent } from './checkpay/checkpay.component';
import { CardpayComponent } from './cardpay/cardpay.component';
import { CashpayComponent } from './cashpay/cashpay.component';
import { PaypalpayComponent } from './paypalpay/paypalpay.component';
import { SatispaypayComponent } from './satispaypay/satispaypay.component';
import { CardpaykoComponent } from './cardpayko/cardpayko.component';
import { CardpayokComponent } from './cardpayok/cardpayok.component';
import { AuthGuard } from '../shared/guard/auth.guard';
import { RestaurantViewComponent } from './restaurant-view/restaurant-view.component';
import { RegisterComponent } from '../pages/account/register/register.component';
import { ListComponent } from '../restaurant/list/restaurants/list/list.component';
import { OrderdetailComponent } from '../pages/account/order-detail/order-detail.component';

const routes: Routes = [
 /* {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },*/
  /* {
    path: '',
    component: HomeComponent
  }, */
  {
    path: '',
    component: ListComponent,
    data: { category: '0', service: '1' }
  },
  {
    path: 'home',
    //component: HomeComponent
    component: ListComponent,
    data: { category: '0', service: '1' }
  },
  /*{
    path: 'home1',
    component: Home1Component
  },*/
  {
    path: 'ristoranti/:slug',
    component: RestaurantViewComponent,
    resolve: {
      data: SeoResolver
    }
  },  
  {
    path: 'ristoranti/asporto/:slug',
    component: RestTakeawayComponent,
    resolve: {
      data: SeotaResolver
    }
  },  
  {
    path: 'domicilio/:slug',
    component: DomicilioComponent,
    resolve: {
      data: DomicilioResolver,
    }
  },
  {
    path: 'domicilio/:slug/:slugt',
    component: DomicilioComponent,
    resolve: {
      data: DomicilioResolver,
    }
  },
  { 
    path: 'login', 
    component: LoginComponent 
  },
  { 
    path: 'register-affiliate/:code', 
    component: RegisterComponent 
  },
  { 
    path: 'account', 
    component: DashboardComponent 
  },
  { 
    path: 'i-miei-ordini', 
    component: DashboardComponent,
    data: { tab: '2' }
  },
  { 
    path: 'logout', 
    component: DashboardComponent,
    data: { tab: '6' }
  },
  { 
    path: 'profile', 
    component: ProfileComponent 
  },
  {
    path: 'ordini/:id',
    component: OrderdetailComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'cookie-policy',
    component: CookiePolicyComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'suggerisci-un-ristorante',
    component: SuggestRestaurantComponent
  },
  {
    path: 'reviews/:ft/:gr/:id', ////for tables, goodreview, orderid
    component: RecensioniComponent
  },
  {
    path: 'cart',
    //canActivate: [AuthGuard],
    component: CartComponent
  },
  {
    path: 'checkout',
    //canActivate: [AuthGuard],
    component: CheckoutComponent
  },
  {
    path: 'checkout/success/:id',
    component: SuccessComponent
  },
  {
    path: 'checkpay',
    //canActivate: [AuthGuard],
    component: CheckpayComponent
  },  
  {
    path: 'check',
    component: CheckComponent
  }, 
  {
    path: 'cardpay',
    canActivate: [AuthGuard],
    component: CardpayComponent
  }, 
  {
    path: 'cardpayok',
    component: CardpayokComponent
  }, 
  {
    path: 'cardpayko',
    component: CardpaykoComponent
  }, 
  {
    path: 'cashpay',
    canActivate: [AuthGuard],
    component: CashpayComponent
  }, 
  {
    path: 'paypalpay',
    canActivate: [AuthGuard],
    component: PaypalpayComponent
  },  
  {
    path: 'satispay',
    component: SatispaypayComponent
  },
  

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
